import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';

const ErrorPage = ({
  title = 'Something went wrong',
  message = 'We encountered an unexpected error.',
  showHomeButton = true,
  showSearchButton = true,
  showBackButton = false,
  backLink = '/',
  backText = 'Go Back'
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-videbits-50 via-pink-50 to-videbits-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Logo */}
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <img
              src="/logo-transparent.svg"
              alt="VideBits Logo"
              className="w-12 h-12"
            />
            <span className="text-2xl font-light text-gray-900">VideBits</span>
          </Link>
        </div>

        {/* Error Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-6">
          {/* Error Icon */}
          <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-videbits-100 to-pink-100 rounded-full flex items-center justify-center">
            <svg
              className="w-8 h-8 text-videbits-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-gray-900 mb-3">
            {title}
          </h1>

          {/* Message */}
          <p className="text-gray-600 mb-8">
            {message}
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {showBackButton && (
              <Link
                to={backLink}
                className="inline-flex items-center justify-center px-6 py-3 bg-videbits-100 text-videbits-700 font-medium rounded-xl hover:bg-videbits-200 transition-colors"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                {backText}
              </Link>
            )}
            {showHomeButton && (
              <Link
                to="/"
                className="inline-flex items-center justify-center px-6 py-3 bg-videbits-600 text-white font-medium rounded-xl hover:bg-videbits-700 transition-colors"
              >
                <Home className="w-4 h-4 mr-2" />
                Back to Home
              </Link>
            )}
            {showSearchButton && (
              <Link
                to="/"
                className="inline-flex items-center justify-center px-6 py-3 bg-white border-2 border-videbits-600 text-videbits-600 font-medium rounded-xl hover:bg-videbits-50 transition-colors"
              >
                <Search className="w-4 h-4 mr-2" />
                Search Titles
              </Link>
            )}
          </div>
        </div>

        {/* Footer */}
        <p className="text-sm text-gray-500">
          Need help? <a href="mailto:support@videbits.com" className="text-videbits-600 hover:underline">Contact Support</a>
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
